import { allPredefinedFilters } from 'app/area/search-filters/constants';
import { FilterPayloadValues, PredefinedIds } from 'app/area/search-filters/filters/types';
import { serializeCodes } from 'app/area/search-filters/serialize/serialize';
import { SerializePayload } from 'app/area/search-filters/types';
import { FilterCommonTypes, PredefinedFilterObject } from 'app/area/search-filters/types-store';
import { ComplexValue } from 'app/types-shared';
import { filterId, queryFilters } from './constants';
import { FavouriteSearchModel } from './types-store';

const serializeQuery = (query: string, value: ComplexValue<number | string>[]) => {
  const trimmedQuery = query?.trim();
  const searchOnAllLevels = (value || []).some(v => v.value === queryFilters.folderPath);

  return trimmedQuery?.length
    ? {
      [filterId.query]: {
        text: trimmedQuery,
        ...(!!value && { searchOnAllLevels })
      }
    }
    : {};
};

export const serialize = (dataToSerialize: SerializePayload): FavouriteSearchModel => {

  const { query, queryValues, formValues, menuValues, filters, filterValidation } = dataToSerialize;

  return {
    ...serializeQuery(query, queryValues),
    ...serializePredefined(formValues),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };
};

export const serializePredefined = (
  formValues: FilterPayloadValues<FilterCommonTypes>
): { [key: string]: PredefinedFilterObject | boolean } => {

  const include = formValues && formValues[PredefinedIds.include] || [];
  const exclude = formValues && formValues[PredefinedIds.exclude] || [];

  return {
    ...(include.some(i => i.value === allPredefinedFilters.excludeInactiveOwners) && {
      [filterId.excludeInactiveOwners]: { enabled: true, negated: true }
    }),

    ...(exclude.some(i => i.value === allPredefinedFilters.excludeInactiveOwners) && {
      [filterId.excludeInactiveOwners]: { enabled: true, negated: false }
    }),

    ...(include.some(i => i.value === allPredefinedFilters.excludeUsedInDashboard) && {
      [filterId.excludeUsedInDashboard]: { enabled: true, negated: true }
    }),

    ...(exclude.some(i => i.value === allPredefinedFilters.excludeUsedInDashboard) && {
      [filterId.excludeUsedInDashboard]: { enabled: true, negated: false }
    }),

    ...(include.some(i => i.value === allPredefinedFilters.excludeUsedInCompanyReport) && {
      [filterId.excludeUsedInCompanyReport]: { enabled: true, negated: true }
    }),

    ...(exclude.some(i => i.value === allPredefinedFilters.excludeUsedInCompanyReport) && {
      [filterId.excludeUsedInCompanyReport]: { enabled: true, negated: false }
    }),

    ...(include.some(i => i.value === allPredefinedFilters.excludeSharedInReport) && {
      [filterId.excludeSharedInReport]: { enabled: true, negated: true }
    }),

    ...(exclude.some(i => i.value === allPredefinedFilters.excludeSharedInReport) && {
      [filterId.excludeSharedInReport]: { enabled: true, negated: false }
    }),

    ...(include.some(i => i.value === allPredefinedFilters.excludeInvalidOwners) && {
      [filterId.excludeInvalidOwners]: { enabled: true, negated: true }
    }),

    ...(exclude.some(i => i.value === allPredefinedFilters.excludeInvalidOwners) && {
      [filterId.excludeInvalidOwners]: { enabled: true, negated: false }
    })
  };
};
